export default "__VITE_ASSET__DTL5Sbj3__"